import { IgrColumn } from "./igr-column";
import { GridCellEditEndedEventArgs as GridCellEditEndedEventArgs_internal } from "./GridCellEditEndedEventArgs";
var IgrGridCellEditEndedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridCellEditEndedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridCellEditEndedEventArgs.prototype.createImplementation = function () {
        return new GridCellEditEndedEventArgs_internal();
    };
    Object.defineProperty(IgrGridCellEditEndedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridCellEditEndedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridCellEditEndedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridCellEditEndedEventArgs.prototype, "column", {
        /**
         * Gets the column of the cell that ended editing.
        */
        get: function () {
            if (this.i.a == null) {
                return null;
            }
            if (!this.i.a.externalObject) {
                var e = IgrColumn._createFromInternal(this.i.a);
                if (e) {
                    e._implementation = this.i.a;
                }
                this.i.a.externalObject = e;
            }
            return this.i.a.externalObject;
        },
        set: function (v) {
            v == null ? this.i.a = null : this.i.a = v.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellEditEndedEventArgs.prototype, "row", {
        /**
         * Gets the row index of the cell that ended editing.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellEditEndedEventArgs.prototype, "item", {
        /**
         * Gets the row item.
        */
        get: function () {
            return this.i.item;
        },
        set: function (v) {
            this.i.item = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridCellEditEndedEventArgs;
}());
export { IgrGridCellEditEndedEventArgs };
//# sourceMappingURL=igr-grid-cell-edit-ended-event-args.js.map
